import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import App from '@/App'
import { AuthProvider } from '@/contexts/AuthContext'
import { InstitutionProvider } from '@/contexts/InstitutionContext'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <InstitutionProvider>
        <App />
      </InstitutionProvider>
    </AuthProvider>
  </StrictMode>,
)
